import { render, staticRenderFns } from "./TreeViewCustomer.vue?vue&type=template&id=53cb5f3b&scoped=true"
import script from "./TreeViewCustomer.vue?vue&type=script&lang=js"
export * from "./TreeViewCustomer.vue?vue&type=script&lang=js"
import style0 from "./TreeViewCustomer.vue?vue&type=style&index=0&id=53cb5f3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb5f3b",
  null
  
)

export default component.exports